export class Theme {
    public static setTheme(value: string) {
        document.getElementsByTagName("body")[0].className = value;
    }
}
